export function getFileName(url: string): string {
  if (!url || url.indexOf("/") === -1) {
    return "";
  }

  return url.split("/").pop() as string;
}
